module.exports = __webpack_public_path__ + "img/weixin.d4cec09c.png";